import { Order } from '@@types/index';
import useAdminOrder from '@hooks/admin/useAdminOrder';
import { useCallback, useEffect, useState } from 'react';

const AUTO_REFRESH_INTERVAL = 60000;

export default function useTableOrders(workspaceId: string | undefined, orderSessionId: number | undefined) {
  const { fetchOrderSession } = useAdminOrder(String(workspaceId));
  const [orders, setOrders] = useState<Order[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  const fetchOrders = useCallback(() => {
    if (!orderSessionId) {
      setOrders([]);
      return;
    }

    setIsLoading(true);
    fetchOrderSession(orderSessionId)
      .then((response) => setOrders(response.data))
      .catch((error) => console.error('테이블 주문을 가져오는 중 오류 발생:', error))
      .finally(() => setIsLoading(false));
  }, [orderSessionId]);

  useEffect(() => {
    fetchOrders();
    const intervalId = setInterval(fetchOrders, AUTO_REFRESH_INTERVAL);
    return () => clearInterval(intervalId);
  }, [fetchOrders]);

  return { orders, fetchOrders, isLoading };
}
